import { useState } from 'react';
import { IconName, SvgIconButton } from '@ardoq/icons';
import { NO_LINK_TARGET_DECORATION } from '../consts';

type GroupExpanderVisualProperties = {
  collapsed: boolean;
  cx?: number;
  cy?: number;
  radius?: number;
};
const GroupExpanderVisual = ({
  collapsed,
  cx,
  cy,
  radius,
}: GroupExpanderVisualProperties) => {
  const [iconButtonState, setIconButtonState] =
    useState<React.ComponentProps<typeof SvgIconButton>['state']>('initial');
  return (
    <SvgIconButton
      className={NO_LINK_TARGET_DECORATION}
      iconName={collapsed ? IconName.UNFOLD_MORE : IconName.UNFOLD_LESS}
      state={iconButtonState}
      cx={cx}
      cy={cy}
      radius={radius}
      onMouseOver={() => setIconButtonState('hover')}
      onMouseOut={() => setIconButtonState('initial')}
      onMouseDown={() => setIconButtonState('pressed')}
      onMouseUp={() => setIconButtonState('initial')}
    />
  );
};

export { GroupExpanderVisual };
